<pbc-filter [config]="VorlagenFilterConfig" [filter]="vorlagen.filter$ | async" (filterChange)="vorlagen.filter$.next($event)"></pbc-filter>
